<div>
	<abonne-logo-uploader
		[abonne]="abonne"
		[canEdit]="true"
		(onSuccessfullUpload)="onSuccessfullUpload()"
	>
	</abonne-logo-uploader>
</div>
